import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppVideoQuizPage } from './app-video-quiz';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppVideoQuizPage,
  ],
  imports: [
    IonicPageModule.forChild(AppVideoQuizPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppVideoQuizPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-video-quiz/app-video-quiz.module.ts